export function wsUrl(): string {
  const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${window.location.host}/ws`;
}

export function listenerUrl(code: string): string {
  return `${window.location.origin}/listen/${encodeURIComponent(code)}`;
}
